import { TypedDocumentNode, gql } from '@apollo/client';
import { ReactNode } from 'react';
import { generatePath } from 'react-router-dom';
import styled from 'styled-components';

import { ManagerPoints as DumbManagerPoints } from '@sorare/core/src/components/rivals/ManagerPoints';
import Avatar from '@sorare/core/src/components/user/Avatar';
import { FOOTBALL_MY_CLUB_SLUG } from '@sorare/core/src/constants/__generated__/routes';

import {
  ManagerPoints_footballRivalsLineup,
  ManagerPoints_pollingFootballRivalsLineup,
} from './__generated__/index.graphql';

const StyledDumbManagerPoints = styled(DumbManagerPoints)`
  flex: 1;
  overflow: hidden;
`;

type Props = {
  lineup: ManagerPoints_footballRivalsLineup | null;
  opponentScore?: number;
  revertLayout?: boolean;
  topRightExtra?: ReactNode;
  disableProfileLink?: boolean;
  displayExactScore?: boolean;
};
export const ManagerPoints = ({
  lineup,
  opponentScore,
  revertLayout,
  topRightExtra,
  disableProfileLink,
  displayExactScore,
}: Props) => {
  const { manager } = lineup || {};
  const { nickname = '', user } = manager || {};

  if (!manager) {
    return null;
  }

  return (
    <StyledDumbManagerPoints
      managerProfileUrl={
        disableProfileLink
          ? undefined
          : generatePath(FOOTBALL_MY_CLUB_SLUG, {
              slug: manager.user.slug,
            })
      }
      name={nickname}
      avatar={user ? <Avatar user={user} rounded variant="medium" /> : null}
      score={lineup?.score || 0}
      opponentScore={opponentScore}
      displayExactScore={displayExactScore}
      revertLayout={revertLayout}
      topRightExtra={topRightExtra}
    />
  );
};

ManagerPoints.pollingFragments = {
  footballRivalsLineup: gql`
    fragment ManagerPoints_pollingFootballRivalsLineup on FootballRivalsLineup {
      id
      score
    }
  ` as TypedDocumentNode<ManagerPoints_pollingFootballRivalsLineup>,
};

ManagerPoints.fragments = {
  footballRivalsLineup: gql`
    fragment ManagerPoints_footballRivalsLineup on FootballRivalsLineup {
      id
      manager {
        id
        nickname
        user {
          slug
          ...Avatar_user
        }
      }
      ...ManagerPoints_pollingFootballRivalsLineup
    }
    ${Avatar.fragments.user}
    ${ManagerPoints.pollingFragments.footballRivalsLineup}
  ` as TypedDocumentNode<ManagerPoints_footballRivalsLineup>,
};
